/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_Max_InstallmentsInputs */

const en_clients_payment_terms_max_installments = /** @type {(inputs: Clients_Payment_Terms_Max_InstallmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum number of installments`)
};

const pt_br2_clients_payment_terms_max_installments = /** @type {(inputs: Clients_Payment_Terms_Max_InstallmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de parcelas`)
};

/**
* | output |
* | --- |
* | "Maximum number of installments" |
*
* @param {Clients_Payment_Terms_Max_InstallmentsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_max_installments = /** @type {((inputs?: Clients_Payment_Terms_Max_InstallmentsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_Max_InstallmentsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_max_installments(inputs)
	return pt_br2_clients_payment_terms_max_installments(inputs)
});